<div class="container-fluid py-4">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2><i class="bi" [ngClass]="isEdit ? 'bi-pencil' : 'bi-ev-station'" class="text-warning me-2"></i>{{ (isEdit ?
        'reservations.title_edit' : 'reservations.title_new') | translate }}</h2>
      <p class="text-muted mb-0">{{ (isEdit ? 'reservations.edit_subtitle' : 'reservations.new_subtitle') | translate }}
      </p>
    </div>
    <button class="btn btn-outline-primary" (click)="goBack()">
      <i class="bi bi-arrow-left me-2"></i>{{ 'back' | translate }}
    </button>
  </div>

  <!-- Form -->
  <div class="card" *ngIf="!isEdit || reservation.id_location">
    <div class="rep-card-header"><i class="bi bi-lightning-charge me-2"></i>{{ 'reservations.details' | translate }}
    </div>
    <div class="card-body">
      <form ngNativeValidate (ngSubmit)="onSubmit()">
        <fieldset [disabled]="disabled" class="border-0 p-0 m-0">

          <!-- Location Section -->
          <h6 class="section-title"><i class="bi bi-geo-alt me-2"></i>{{ 'reservations.location_section' | translate }}
          </h6>
          <div class="row mb-4">
            <div class="col-md-6 mb-3">
              <label class="form-label">{{ 'reservations.location' | translate }} *</label>
              <s-select name="id_location" [items]="locations" bindLabel="name" bindValue="id_location"
                [placeholder]="'reservations.location_placeholder' | translate" [required]="true" [disabled]="disabled"
                [(model)]="reservation.id_location" (change)="onLocationChange($event?.id_location); onFormChange()">
              </s-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">{{ 'reservations.station' | translate }} *</label>
              <s-select name="id_station" [items]="stations" bindLabel="name" bindValue="id_station"
                [placeholder]="'reservations.station_placeholder' | translate" [required]="true"
                [disabled]="disabled || !stations.length" [(model)]="reservation.id_station" (change)="onFormChange()">
              </s-select>
            </div>
          </div>

          <!-- Time Section -->
          <h6 class="section-title"><i class="bi bi-clock me-2"></i>{{ 'reservations.time_section' | translate }}</h6>
          <div class="row mb-4">
            <div class="col-md-3 mb-3">
              <label class="form-label">{{ 'reservations.date' | translate }} *</label>
              <s-input type="date" name="date" [(model)]="reservation.date" [required]="true"
                (modelChange)="onFormChange()"></s-input>
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">{{ 'reservations.time_start' | translate }} *</label>
              <s-input type="time" name="time" [(model)]="reservation.time" [required]="true"
                (modelChange)="onFormChange()"></s-input>
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">{{ 'reservations.duration' | translate }} *</label>
              <s-select name="duration_minutes" [items]="durationOptions" bindLabel="label" bindValue="duration_minutes"
                [clearable]="false" [required]="true" [disabled]="disabled" [(model)]="reservation.duration_minutes"
                (change)="onFormChange()">
              </s-select>
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">{{ 'reservations.time_end' | translate }}</label>
              <input type="text" class="form-control bg-light"
                [value]="(calculatedEndTime | date:'HH:mm') || ('reservations.auto' | translate)" readonly>
            </div>
          </div>

          <!-- Vehicle Section -->
          <h6 class="section-title"><i class="bi bi-car-front me-2"></i>{{ 'reservations.vehicle_section' | translate }}
          </h6>
          <div class="row mb-4">
            <div class="col-md-4 mb-3">
              <label class="form-label">{{ 'reservations.vehicle_type' | translate }} *</label>
              <s-select name="id_vehicle_type" [items]="vehicleTypes" bindLabel="name" bindValue="id_vehicle_type"
                [clearable]="false" [required]="true" [disabled]="disabled" [(model)]="reservation.id_vehicle_type"
                (change)="onFormChange()">
              </s-select>
              <small class="text-muted" *ngIf="estimatedEnergyKwh != null">
                {{ 'reservations.estimated_energy' | translate }}
                <strong>~{{ estimatedEnergyKwh }} kWh</strong>
              </small>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">{{ 'reservations.license_plate' | translate }} *</label>
              <s-input type="text" name="license_plate" customClass="text-uppercase"
                [(model)]="reservation.license_plate"
                [placeholder]="'reservations.license_plate_placeholder' | translate" [required]="true"></s-input>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-4">
            <label class="form-label">{{ 'reservations.notes' | translate }}</label>
            <s-input type="textarea" name="notes" [(model)]="reservation.notes"
              [placeholder]="'reservations.notes_placeholder' | translate"></s-input>
          </div>

          <!-- Admin only: status + notify -->
          <div class="row mb-4" *ngIf="isAdmin && isEdit">
            <div class="col-md-4 mb-3">
              <label class="form-label">{{ 'status.status' | translate }} *</label>
              <s-select name="status" [items]="statusOptions" bindLabel="label" bindValue="value"
                [clearable]="false" [required]="true" [disabled]="disabled" [(model)]="reservation.status">
              </s-select>
            </div>
            <div class="col-md-8 mb-3 d-flex align-items-end">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="res-notify" name="notify_user"
                  [(ngModel)]="reservation.notify_user">
                <label class="form-check-label" for="res-notify">
                  <i class="bi bi-envelope me-2"></i>{{ 'admin.reservations.notify_user' | translate }}
                </label>
              </div>
            </div>
          </div>

        </fieldset>

        <!-- Availability -->
        <div class="alert alert-success" *ngIf="availabilityChecked && isAvailable">
          <i class="bi bi-check-circle me-2"></i>{{ 'reservations.available' | translate }}
        </div>
        <div class="alert alert-danger" *ngIf="availabilityChecked && !isAvailable">
          <i class="bi bi-x-circle me-2"></i>{{ 'reservations.unavailable' | translate }}
        </div>

        <!-- Actions -->
        <div class="form-actions">
          <button type="button" class="btn btn-outline-info" (click)="checkAvailability()" [disabled]="disabled">
            <i class="bi bi-search me-2"></i>{{ 'reservations.check_availability' | translate }}
          </button>
          <div>
            <button *ngIf="isEdit && reservation.status === 'CONFIRMED'" type="button" class="btn btn-outline-danger me-2"
              [disabled]="disabled" (click)="cancelReservation()">
              <i class="bi bi-x me-2"></i>{{ 'reservations.cancel_btn' | translate }}
            </button>
            <button type="button" class="btn btn-secondary me-2" (click)="goBack()">{{ 'back' | translate }}</button>
            <button type="submit" class="btn btn-accent" [disabled]="isSaving || disabled">
              <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isSaving" class="bi bi-save me-2"></i>{{ (isEdit ? 'save' : 'create') | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mt-2" *ngIf="selectedStationMapPoints.length">
    <div class="card-body ">
      <app-station-map [stations]="selectedStationMapPoints" height="400px"></app-station-map>
    </div>
  </div>
</div>